import { aboutFacts, aboutIntro } from "@/content/trust";
import { site } from "@/content/site";
import { Card } from "@/components/ui/Card";
import { GlobalCTA } from "@/components/ui/CTA";
import { PageHero } from "@/components/ui/PageHero";
import { Section } from "@/components/ui/Section";

export default function AboutPage() {
  return (
    <>
      <PageHero eyebrow="About" title="Accountable creative growth" description={aboutIntro} />

      <Section title="What guides the product" tone="surface">
        <div className="grid gap-6 md:grid-cols-2">
          {aboutFacts.map((fact) => (
            <Card key={fact.title} title={fact.title} description={fact.description} />
          ))}
        </div>
      </Section>

      <Section title="Company facts" tone="paper">
        <dl className="grid gap-6 md:grid-cols-3">
          <div className="surface-card p-6">
            <dt className="text-sm font-bold uppercase tracking-wide text-mint-dark">Brand</dt>
            <dd className="mt-2 text-xl font-bold">{site.name}</dd>
          </div>
          <div className="surface-card p-6">
            <dt className="text-sm font-bold uppercase tracking-wide text-mint-dark">Domain</dt>
            <dd className="mt-2 text-xl font-bold">agenticplus.dev</dd>
          </div>
          <div className="surface-card p-6">
            <dt className="text-sm font-bold uppercase tracking-wide text-mint-dark">Contact</dt>
            <dd className="mt-2 text-xl font-bold">
              <a className="underline" href={`mailto:${site.email}`}>
                {site.email}
              </a>
            </dd>
          </div>
        </dl>
      </Section>

      <GlobalCTA />
    </>
  );
}
